import React from 'react';

function ChildrenYouthIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.12 255.12">
      <g id="Ebene_1" data-name="Ebene 1">
        <path
          fill="var(--primary-font-color)"
          d="M187.42,101.78v52a9.18,9.18,0,0,1-9.18,9.18h-6.12v52a9.18,9.18,0,0,1-9.18,9.18H138.47a9.18,9.18,0,0,1-9.18-9.18V163h-6.12a9.18,9.18,0,0,1-9.18-9.18v-52a18.36,18.36,0,0,1,18.36-18.36h4.34a33.62,33.62,0,0,0,28,0h4.34A18.36,18.36,0,0,1,187.42,101.78Zm-12.24-49A24.48,24.48,0,1,1,150.7,28.35,24.48,24.48,0,0,1,175.18,52.82Z"
        ></path>
        <path
          fill="var(--primary-font-color)"
          d="M142.69,135.47,121,157.19V218.4a7.34,7.34,0,0,1-7.34,7.34H110a7.34,7.34,0,0,1-7.34-7.34V192.7H99v25.7a7.34,7.34,0,0,1-7.34,7.34H87.94a7.35,7.35,0,0,1-7.35-7.34V157.19L58.88,135.47a7.34,7.34,0,0,1,10.38-10.38L89.14,145h23.29l19.88-19.88a7.34,7.34,0,0,1,10.38,10.38Zm-41.9-27.22a16.52,16.52,0,1,1-16.53,16.52A16.52,16.52,0,0,1,100.79,108.25Z"
        ></path>
        <path
          fill="var(--background-color)"
          d="M113.64,226.77H110a8.39,8.39,0,0,1-8.37-8.37V193.73H100V218.4a8.38,8.38,0,0,1-8.37,8.37H87.93a8.39,8.39,0,0,1-8.37-8.37V157.61L58.15,136.2a8.37,8.37,0,0,1,0-11.84,8.35,8.35,0,0,1,11.84,0l19.58,19.57H112l19.58-19.57a8.35,8.35,0,0,1,11.84,0,8.37,8.37,0,0,1,0,11.84L122,157.61V218.4A8.39,8.39,0,0,1,113.64,226.77ZM97.92,191.66h5.73V218.4a6.32,6.32,0,0,0,6.31,6.31h3.68A6.32,6.32,0,0,0,120,218.4V156.76l22-22a6.31,6.31,0,1,0-8.92-8.92L112.86,146H88.71L68.53,125.82a6.31,6.31,0,1,0-8.92,8.92l22,22V218.4a6.32,6.32,0,0,0,6.31,6.31h3.68a6.32,6.32,0,0,0,6.31-6.31Zm2.87-49.33a17.56,17.56,0,1,1,17.55-17.56A17.58,17.58,0,0,1,100.79,142.33Zm0-33.05a15.49,15.49,0,1,0,15.48,15.49A15.5,15.5,0,0,0,100.79,109.28Z"
        ></path>
      </g>
    </svg>
  );
}
export default ChildrenYouthIcon;
